import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment'; // Ajuste o caminho conforme sua estrutura
import { CommonService } from '../../common-service'; // Ajuste o caminho conforme sua estrutura
import { ListarDocumentosFiscaisRecebidosRequest } from '../../requests/repo-dfe/listar-documentos-fiscais-recebidos.request';
import { ListarDocumentosFiscaisRecebidosResponse } from '../../responses/repo-dfe/listar-documentos-fiscais-recebidos.response';
import { DownloadDocumentosFiscaisRecebidosRequest } from '../../requests/repo-dfe/download-documentos-fiscais-recebidos.request';
import { DownloadDocumentosFiscaisRecebidosResponse } from '../../responses/repo-dfe/download-documentos-fiscais-recebidos.response';
import { DetalheNFeRecebidoResponse } from '../../responses/repo-dfe/detalhe-nfe-recebido.response';
import { DetalheCTeRecebidoResponse } from '../../responses/repo-dfe/detalhe-cte-recebido.response';
import { OrigemDocumentoFiscalRecebidoEnum } from '../../../enums/repo-dfe/origem-documento-fiscal-recebido.enum';

@Injectable({
  providedIn: 'root',
})
export class PainelDFeRecebidoService extends CommonService {
  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  // A URL base para o controller PainelDFeRecebido.
  // Certifique-se de que a variável 'urlApiRepoDFe' existe no seu arquivo environment.ts
  private readonly apiUrl = `${environment.urlApiRepoDFe}paineldferecebido`;

  /**
   * Obtém uma lista paginada de DFes Recebidos.
   * Corresponde a: [HttpPost("getAll")]
   * @param request O objeto com os filtros da busca.
   * @param paginaAtual O número da página a ser retornada.
   */
  public getAll(request: ListarDocumentosFiscaisRecebidosRequest, paginaAtual: number = 0): Observable<ListarDocumentosFiscaisRecebidosResponse> {
    const url = `${this.apiUrl}/getAll`;
    const params = new HttpParams().set('paginaAtual', paginaAtual.toString());

    return this.httpClient
      .post<ListarDocumentosFiscaisRecebidosResponse>(url, request, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  public obterNFeRecebido(idNFeRecebido: number, origemDocumentoFiscalRecebido: OrigemDocumentoFiscalRecebidoEnum): Observable<DetalheNFeRecebidoResponse> {
    const url = `${this.apiUrl}/nfe/idNFeRecebido/${idNFeRecebido}`;
    const params = new HttpParams().set('origemDocumentoFiscalRecebido', origemDocumentoFiscalRecebido.toString());
    return this.httpClient
      .get<DetalheNFeRecebidoResponse>(url, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  public obterCTeRecebido(idCTeRecebido: number, origemDocumentoFiscalRecebido: OrigemDocumentoFiscalRecebidoEnum): Observable<DetalheCTeRecebidoResponse> {
    const url = `${this.apiUrl}/cte/idCTeRecebido/${idCTeRecebido}`;
    const params = new HttpParams().set('origemDocumentoFiscalRecebido', origemDocumentoFiscalRecebido.toString());
    return this.httpClient
      .get<DetalheCTeRecebidoResponse>(url, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  /**
   * Solicita o download do XML de um ou mais DFes recebidos.
   * A resposta contém os dados do arquivo (único ou zip) em base64.
   * Corresponde a: [HttpPost("download")]
   * @param request Objeto contendo a lista de nomes de arquivos XML a serem baixados.
   */
  public downloadDocumentos(request: DownloadDocumentosFiscaisRecebidosRequest): Observable<DownloadDocumentosFiscaisRecebidosResponse> {
    const url = `${this.apiUrl}/download`;

    return this.httpClient
      .post<DownloadDocumentosFiscaisRecebidosResponse>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

}
